export default function () {
	this.key = undefined,
	this.objectTitle = undefined,
	this.objectLatitude = undefined,
	this.objectLongitude = undefined,
	this.userLatitude = undefined,
	this.userLongitude = undefined,
	this.userIcon = undefined
}
